const video_list_modal = document.querySelector(".video-list-modal__dialog");
const video_list_iframe = document.querySelector(".video-list-modal__dialog iframe")
const video_list_close_button = document.querySelector(".video-list-modal__close-button");


function onVideoItemClick(item) {
  let video_info = "";
  
  fetch(`https://www.youtube.com/oembed?url=https://www.youtube.com/shorts/${item}`)
    .then(T => T.json())
    .then(data => {

        if(data.width/data.height < 1) {
          video_list_iframe.style.width = "300px";
        }else{
          video_list_iframe.style.width = "70vw";
        }
      
        video_list_iframe.style.aspectRatio = data.width/data.height;
    });
  
  video_list_iframe.src = `https://www.youtube.com/embed/${item}?enablejsapi=1&playlist=${item}&loop=1&rel=0`;
  video_list_modal.showModal();
}

video_list_modal.addEventListener("click", (event) => {
  if(event.target == video_list_modal) {
    video_list_modal.close();
    video_list_iframe.contentWindow.postMessage('{"event":"command","func":"' + "stopVideo" + '","args":""}', "*");
    video_list_iframe.src = "";
  }
})

video_list_close_button.addEventListener("click", () => {
  video_list_modal.close();
  video_list_iframe.contentWindow.postMessage('{"event":"command","func":"' + "stopVideo" + '","args":""}', "*");
  video_list_iframe.src = "";
})